<app-card-content [border]="false" icon="pi pi-id-card" [title]="'Catálogo de Perfis'" [subtitle]="'Perfis de acesso: conjuntos de roles reutilizáveis para atribuir a usuários'">
    <p-button label="Novo perfil" icon="pi pi-plus" card-header [appCan]="rolePermissaoAdministrar" (onClick)="novo()"></p-button>

    <!-- Filtros -->
    <app-filtros-bar (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
        <app-filtro-campo label="UF">
            <app-estado-select [uf]="filtroUf()" [disabled]="ufTravada()" (ufChange)="filtroUf.set($event)" />
        </app-filtro-campo>
        <app-filtro-campo label="Nome" [wide]="true" inputId="perfis-filtro-nome">
            <input id="perfis-filtro-nome" pInputText type="text" class="w-full" [ngModel]="filtroNome()" (ngModelChange)="filtroNome.set($event)" (keyup.enter)="aplicarFiltros()" placeholder="Buscar por nome..." />
        </app-filtro-campo>
        <app-filtro-campo label="Status">
            <p-select [options]="opcoesStatus" [ngModel]="filtroStatus()" (ngModelChange)="filtroStatus.set($event)" optionLabel="label" optionValue="value" placeholder="Todos os status" [showClear]="true" appendTo="body" styleClass="w-full" />
        </app-filtro-campo>
    </app-filtros-bar>

    <p-table [value]="perfisOrdenados()" [loading]="carregando()" styleClass="p-datatable-sm" [paginator]="true" [rows]="10" rowGroupMode="subheader" groupRowsBy="uf">
        <ng-template pTemplate="header">
            <tr>
                <th>Nome</th>
                <th>Descrição</th>
                <th style="width: 15rem" class="text-center whitespace-nowrap">Roles / Usuários</th>
                <th style="width: 8rem" class="text-center">Status</th>
                <th style="width: 8rem"></th>
            </tr>
        </ng-template>
        <!-- A UF vive no cabeçalho do grupo, não em cada linha: repeti-la em toda linha do mesmo
             grupo seria ruído. Mesmo arranjo do diálogo "Aplicar perfil". -->
        <ng-template pTemplate="groupheader" let-perfil>
            <tr class="bg-surface-50 dark:bg-surface-900">
                <td colspan="5" class="py-2 font-semibold">
                    <app-estado-rotulo [uf]="perfil.uf" />
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-perfil>
            <tr>
                <td>{{ perfil.nmPerfil }}</td>
                <td class="text-muted-color">{{ perfil.dsPerfil }}</td>
                <td class="text-center whitespace-nowrap">
                    {{ perfil.qtdRoles }} roles ·
                    @if (perfil.qtdUsuarios > 0) {
                        <button type="button" class="text-primary font-medium hover:underline" (click)="abrirUsuarios(perfil)">{{ formatarUsuarios(perfil.qtdUsuarios) }}</button>
                    } @else {
                        <span>{{ formatarUsuarios(perfil.qtdUsuarios) }}</span>
                    }
                </td>
                <td class="text-center">
                    <p-tag [severity]="perfil.inAtivo === 'S' ? 'success' : 'danger'" [value]="perfil.inAtivo === 'S' ? 'Ativo' : 'Inativo'" />
                </td>
                <td class="whitespace-nowrap text-right">
                    <p-button icon="pi pi-pencil" ariaLabel="Editar" [text]="true" [rounded]="true" severity="secondary" pTooltip="Editar" [appCan]="rolePermissaoAdministrar" (onClick)="editar(perfil)"></p-button>
                    @if (perfil.inAtivo === 'S') {
                        <p-button icon="pi pi-ban" ariaLabel="Inativar" [text]="true" [rounded]="true" severity="warn" pTooltip="Inativar" [appCan]="rolePermissaoAdministrar" (onClick)="confirmarInativar(perfil)"></p-button>
                    } @else {
                        <p-button icon="pi pi-check-circle" ariaLabel="Reativar" [text]="true" [rounded]="true" severity="success" pTooltip="Reativar" [appCan]="rolePermissaoAdministrar" (onClick)="confirmarReativar(perfil)"></p-button>
                    }
                    <p-button icon="pi pi-trash" ariaLabel="Excluir" [text]="true" [rounded]="true" severity="danger" pTooltip="Excluir" [appCan]="rolePermissaoAdministrar" (onClick)="confirmarExcluir(perfil)"></p-button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="text-center text-muted-color py-6">Nenhum perfil encontrado.</td>
            </tr>
        </ng-template>
    </p-table>
</app-card-content>

<p-dialog appDialogoPadrao="pi pi-shield" descricao="Quem herda as permissões do perfil." header="Usuários com este perfil" [visible]="dialogUsuariosAberto()" [style]="{ width: '28rem', maxWidth: '95vw' }" (onHide)="fecharUsuarios()">
    @if (carregandoUsuarios()) {
        <div class="p-4 text-center"><i class="pi pi-spin pi-spinner"></i></div>
    } @else if (erroUsuarios()) {
        <div class="p-4 text-center texto-aviso">
            <i class="pi pi-exclamation-triangle mr-2"></i>
            Não foi possível carregar os usuários deste perfil.
        </div>
    } @else if (usuariosDoPerfilSel().length === 0) {
        <div class="text-sm text-muted-color text-center py-6">Nenhum usuário com este perfil.</div>
    } @else {
        <div class="flex flex-col gap-1 max-h-80 overflow-auto">
            @for (u of usuariosDoPerfilSel(); track u.idWebUsuario) {
                <div class="flex items-center justify-between gap-2 px-2 py-1.5 rounded hover:bg-surface-100 dark:hover:bg-surface-800">
                    <span class="text-sm truncate">{{ u.nmSolicitante || u.userId }}</span>
                    @if (u.ufSolicitante) {
                        <span class="text-xs text-muted-color shrink-0">{{ u.ufSolicitante }}</span>
                    }
                </div>
            }
        </div>
    }
    <ng-template pTemplate="footer">
        <p-button label="Fechar" severity="secondary" (onClick)="fecharUsuarios()"></p-button>
    </ng-template>
</p-dialog>

<p-confirmdialog></p-confirmdialog>
